import { render, staticRenderFns } from "./wine-pack.vue?vue&type=template&id=6cd6d6b2"
import script from "./wine-pack.vue?vue&type=script&lang=js"
export * from "./wine-pack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports